<div class="container appinfo">
    <div class="row m-0">
        <div class="main_content mt-2">
            <span class="text-lg-right float-lg-right">
                <button type="button" class="btnCancelSub" name="btncancelmySubmissionName" id="btncancelmySubmissionID"
                    [disabled]="indicationQG.isClearedSubmission"
                    (click)="cancelMySubmissionPopUp()" title="Cancel my Submission">
                    <i class="fa fa-times" aria-hidden="true"></i>
                    Cancel my Submission
                </button>
            </span>
            <form #applicationForm="ngForm" style="width:100%">
                <!-- Price Indication starts -->
                <div ngModelGroup="indication"  *ngIf="indicationQG.showPriceIndication">
                    <h3>Premium Indication</h3>               
                    <p-table class="table llh_table" [style]="{'margin-top': '20px'}"
                    [class.notallowed]="indicationQG.isClearedSubmission">
                        <ng-template pTemplate="header">
                            <tr>
                                <th rowspan="2" class="text-center" style="vertical-align: middle !important;font-size: 22px;">Coverages</th>
                                <th class="text-center" colspan="3" style="font-size: larger;">
                                      {{ indicationQG.hasAutoPhyDamage ? 'Available APD Deductible Options For Selection' : 'Premiums' }}
                                </th>
                            </tr>
                            <tr>
                                <th class="text-center" style="font-size: larger;">User Selected</th>
                                <th class="text-center" style="font-size: larger;" *ngIf="indicationQG.hasAutoPhyDamage">Option 1 - $ 1000</th>
                                <th class="text-center" style="font-size: larger;" *ngIf="indicationQG.hasAutoPhyDamage">Option 2 - $ 2500</th>
                            </tr>
                            <tr>
                                <td class="text-center">Auto Liability</td>
                                <td class="text-center">{{indicationQG.autoliabPremiums[0]?.minimum | currency:'USD' : 'symbol':'1.0-0'}} - {{indicationQG.autoliabPremiums[0]?.maximum | currency:'USD' : 'symbol':'1.0-0'}}</td>
                                <td class="text-center" *ngIf="indicationQG.hasAutoPhyDamage">{{indicationQG.autoliabPremiums[1]?.minimum | currency:'USD' : 'symbol':'1.0-0'}} - {{indicationQG.autoliabPremiums[1]?.maximum | currency:'USD' : 'symbol':'1.0-0'}}</td>
                                <td class="text-center" *ngIf="indicationQG.hasAutoPhyDamage">{{indicationQG.autoliabPremiums[2]?.minimum | currency:'USD' : 'symbol':'1.0-0'}} - {{indicationQG.autoliabPremiums[2]?.maximum | currency:'USD' : 'symbol':'1.0-0'}}</td>
                            </tr>
                            <tr *ngIf="indicationQG.hasAutoPhyDamage">
                                <td class="text-center">Auto Physical Damage</td>
                                <td class="text-center">{{indicationQG.autoPhyDamagePremiums[0]?.minimum | currency:'USD' : 'symbol':'1.0-0'}} - {{indicationQG.autoPhyDamagePremiums[0]?.maximum | currency:'USD' : 'symbol':'1.0-0'}}</td>
                                <td class="text-center">{{indicationQG.autoPhyDamagePremiums[1]?.minimum | currency:'USD' : 'symbol':'1.0-0'}} - {{indicationQG.autoPhyDamagePremiums[1]?.maximum | currency:'USD' : 'symbol':'1.0-0'}}</td>
                                <td class="text-center">{{indicationQG.autoPhyDamagePremiums[2]?.minimum | currency:'USD' : 'symbol':'1.0-0'}} - {{indicationQG.autoPhyDamagePremiums[2]?.maximum | currency:'USD' : 'symbol':'1.0-0'}}</td>
                            </tr>
                            <tr  *ngIf="indicationQG.isMTCIncluded">
                                <td class="text-center">Motor Truck Cargo</td>
                                <td class="text-center">
                                  {{ areCommoditiesAndMtcEligible
                                    ? (indicationQG.motoTruckPremiums[0]?.minimum | currency:'USD' : 'symbol':'1.0-0') + ' - ' + (indicationQG.motoTruckPremiums[0]?.maximum | currency:'USD' : 'symbol':'1.0-0')
                                      : 'Not Included' }}
                                  <span *ngIf="!areCommoditiesAndMtcEligible" style="color: red;">*</span>
                                </td>
                                <td class="text-center" *ngIf="indicationQG.hasAutoPhyDamage">
                                  {{ areCommoditiesAndMtcEligible 
                                      ? (indicationQG.motoTruckPremiums[1]?.minimum | currency:'USD' : 'symbol':'1.0-0') + ' - ' + (indicationQG.motoTruckPremiums[1]?.maximum | currency:'USD' : 'symbol':'1.0-0')
                                      : 'Not Included' }}
                                  <span *ngIf="!areCommoditiesAndMtcEligible" style="color: red;">*</span>
                                </td>
                                <td class="text-center" *ngIf="indicationQG.hasAutoPhyDamage">
                                  {{ areCommoditiesAndMtcEligible 
                                      ? (indicationQG.motoTruckPremiums[2]?.minimum | currency:'USD' : 'symbol':'1.0-0') + ' - ' + (indicationQG.motoTruckPremiums[2]?.maximum | currency:'USD' : 'symbol':'1.0-0')
                                      : 'Not Included' }}
                                  <span *ngIf="!areCommoditiesAndMtcEligible" style="color: red;">*</span>
                                </td>
                              </tr>                         
                            <tr *ngIf="indicationQG.isGlIncluded">
                                <td class="text-center">General Liability</td>
                                <td class="text-center" >Not Included</td>
                                <td class="text-center" *ngIf="indicationQG.hasAutoPhyDamage">Not Included</td>
                                <td class="text-center" *ngIf="indicationQG.hasAutoPhyDamage">Not Included</td>
                            </tr>
                            <tr>
                                <td class="text-center">Estimated Account Premium</td>
                                <td class="text-center"><b>{{indicationQG.totalPremiums[0]?.minimum | currency:'USD' : 'symbol':'1.0-0'}} -  {{indicationQG.totalPremiums[0]?.maximum | currency:'USD' : 'symbol':'1.0-0'}}</b></td>
                                <td class="text-center" *ngIf="indicationQG.hasAutoPhyDamage"><b>{{indicationQG.totalPremiums[1]?.minimum | currency:'USD' : 'symbol':'1.0-0'}} - {{indicationQG.totalPremiums[1]?.maximum | currency:'USD' : 'symbol':'1.0-0'}}</b></td>
                                <td class="text-center" *ngIf="indicationQG.hasAutoPhyDamage"><b>{{indicationQG.totalPremiums[2]?.minimum | currency:'USD' : 'symbol':'1.0-0'}} - {{indicationQG.totalPremiums[2]?.maximum | currency:'USD' : 'symbol':'1.0-0'}}</b></td>
                            </tr>
                            <tr  *ngIf="!!indicationQG.selectToQuote">
                                <td class="text-center" >Select to Quote <span
                                    style="color: red;">*</span>
                                    <input type="hidden" name="selectToQuoteAnswer" #selectToQuoteAnswer="ngModel" [ngModel]="indicationQG.selectToQuote?.answer" required>
                                </td>
                                <td class="text-center">
                                    <p-checkbox name="selectToQuote" [binary]="true" [trueValue]="indicationQG.selectToQuote?.questionOptions[0]?.code" [falseValue]="''"  (onChange)="quoteSelected($event, indicationQG.selectToQuote?.questionOptions[0].code)"
                                    [(ngModel)]="indicationQG.selectToQuote.answer" [class.invalid_div_cls]="!!applicationForm.submitted && selectToQuoteAnswer.invalid"></p-checkbox> </td>
                                <td class="text-center" *ngIf="indicationQG.hasAutoPhyDamage">
                                    <p-checkbox   name="selectToQuote" [binary]="true" [trueValue]="indicationQG.selectToQuote?.questionOptions[1]?.code" [falseValue]="''" (onChange)="quoteSelected($event, indicationQG.selectToQuote?.questionOptions[1].code)" 
                                    [(ngModel)]="indicationQG.selectToQuote.answer" [class.invalid_div_cls]="!!applicationForm.submitted && selectToQuoteAnswer.invalid"></p-checkbox></td>
                                <td class="text-center" *ngIf="indicationQG.hasAutoPhyDamage">
                                    <p-checkbox  name="selectToQuote" [binary]="true" [trueValue]="indicationQG.selectToQuote?.questionOptions[2]?.code" [falseValue]="''"  (onChange)="quoteSelected($event, indicationQG.selectToQuote?.questionOptions[2].code)"
                                    [(ngModel)]="indicationQG.selectToQuote.answer" [class.invalid_div_cls]="!!applicationForm.submitted && selectToQuoteAnswer.invalid"> </p-checkbox>
                                </td> 
                            </tr>
                        </ng-template>
                    </p-table>

                    <div *ngIf="!areCommoditiesEligible && indicationQG.isMTCIncluded" style="color: rgb(170, 3, 3);margin-bottom: 15px;font-style: italic"><b>*Motor Truck cargo indication is not included and will be reviewed by the underwriter upon submission.</b></div>
                    <div *ngIf="indicationQG.isGlIncluded" style="color: rgb(170, 3, 3);margin-bottom: 15px;font-style: italic"><b>*General Liability indication is not included and will be reviewed by the underwriter upon submission.</b></div>

                    <div style="font-style: italic; margin-bottom: 15px;">
                        <b>
                            The displayed pricing is a good faith estimate of the premium for the requested product based on our preliminary review of information currently available to us.
                            It is not an offer of insurance or a bindable quote.  Our underwriters will further review the application and may request additional information before a final quote can be delivered.
                        </b>
                    </div>
                    
                </div>
                <!-- Price Indication ends -->
                <div class="mt-4 clearfix"></div>     
                <h3 class="mt-2">Application Submission</h3>
                <div class="row mb-2">
                        <div class="col-lg-12" *ngIf="!!applicationInfoModel.applicationDetails">
                            <div class="row" *ngIf="displayIftaFileUpload">
                                <div class="col-md-6">
                                    <label name="lblfileUpload" id="lblfileUploadID" class="upload_label">Upload applicable for the following document</label>
                                    <ul>
                                        <li>
                                            IFTAs- four full quarters including the most recent
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <label>
                                        {{applicationInfoModel.applicationDetails?.iftaDocumentId?.questionLabel}}
                                        <span
                                            style="color: red;">{{applicationInfoModel.applicationDetails?.iftaDocumentId?.required
                                            ? '*' : ''}}</span>
                                    </label>
                                    <a (click)="fileUpload('iftaDocument')" name="iftafileUpload" id="iftafileUploadID" class="drag_and_drop"
                                        [class.notallowed]="indicationQG.isClearedSubmission" 
                                        [class.fileUpload_error_cls]="(applicationForm.submitted || dao?.isSubmitForm) && !iftaDocsSatisfied">
                                        <h3 class="mb-0">
                                            Drag & Drop Files Here
                                        </h3>
                                        <p class="mb-0">or</p>
                                        <h6>
                                            Browse Files
                                        </h6>
                                    </a>
                                    <p-fileUpload name="demo2[]" id="demoID2[]" class="UploadCls iftaDocument"
                                        (onSelect)="onUpload($event)" (click)="clickUpload($event,'iftaDocument')"
                                        [accept]="fileNetAllowedFileExtensions" multiple="multiple"
                                        [disabled]="indicationQG.isClearedSubmission"
                                        invalidFileTypeMessageSummary="{0}: Invalid file type." maxFileSize="15728640">
                                    </p-fileUpload>
                                    <div class="row filesrow" style="margin-top: 20px;"
                                        *ngFor="let item of applicationInfoModel.iftaDocumentFiles; let i= index;">
                                        <div class="col-lg-12">
                                            <div class="col-md-1 upload_file_icon">
                                                <i class="fa fa-file-o" style="margin-left: -2px;" aria-hidden="true"></i>
                                            </div>
                                            <div class="col-md-11 upload_file_details">
                                                <div class="upload_file_name">
                                                    {{item?.fileName}}
                                                </div>
                                                <span class="row text-right float-right upload_size_details"><b
                                                        class="color_dark">({{item?.filesize}})</b>
                                                    <i class="fa fa-times-circle-o ml-2 fa-lg color_green pointerCur"
                                                        [class.notallowed]="indicationQG.isClearedSubmission" 
                                                        title="Delete {{item?.fileName}}" (click)="deleteFile(item,i)"
                                                        aria-hidden="true"></i>
                                                </span><br>
                                                <p-progressBar [value]="item?.progressValue"></p-progressBar>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-12 mt-2">
                                        <div class="small color_grey">
                                            The combined file size limit is 15 MB.
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-2" style="padding: 0px 15px;">
                                <label name="lblquestionInfoText" id="questionInfoTextID"
                                    [class.validationred]="(applicationForm.submitted || dao?.isSubmitForm) && (applicationInfoModel.applicationDetails.motorCarrierFilingParent.answer == null || applicationInfoModel.applicationDetails.motorCarrierFilingParent.answer == '')">
                                    Are motor carrier filings needed for this account? If so, please list the filings needed
                                    <span
                                        style="color: red;">{{applicationInfoModel.applicationDetails?.motorCarrierFilingParent?.required
                                        ?
                                        '*' : ''}}</span>
                                </label>
                                <div class="" style="margin-left: 1%;">
                                    <div class="p-field-radiobutton">
                                        <p-radioButton name="motorCarrierFilingParent" id="motorCarrierFilingParentID"
                                            value="Y" class="radio_button" required inputId="Y"
                                            #motorCarrierFilingParent="ngModel" [disabled]="indicationQG.isClearedSubmission"
                                            [(ngModel)]="applicationInfoModel.applicationDetails.motorCarrierFilingParent.answer">
                                        </p-radioButton>
                                        <label class="radio_button_lbl" name="lblMotorCarrierFilingParent"
                                            id="lblMotorCarrierFilingParentID">Yes</label>
                                        <p-radioButton name="motorCarrierFilingParent" id="motorCarrierFilingParentID"
                                            class="radio_button" value="N" required inputId="N"
                                            #motorCarrierFilingParent="ngModel"  [disabled]="indicationQG.isClearedSubmission"
                                            [(ngModel)]="applicationInfoModel.applicationDetails.motorCarrierFilingParent.answer">
                                        </p-radioButton>
                                        <label class="radio_button_lbl" name="lblMotorCarrierFilingParent"
                                            id="lblMotorCarrierFilingParentID">No</label>
                                    </div>
                                </div>
                            </div>
                            <div class="mt-1" *ngIf="motorCarrierFilingParent.value == 'Y'">
                                <textarea class="form-control" rows="4" required
                                    [class.notallowed]="indicationQG.isClearedSubmission" 
                                    [(ngModel)]="applicationInfoModel.applicationDetails.motorCarrierFilingChild.answer"
                                    name="motorCarrierFilingChild" id="motorCarrierFilingChildID" type="text"></textarea>
                            </div>
                            <div class="mt-2">
                                <label class="" name="lblquestionInfoText" id="questionInfoTextID">
                                    Enter any notes you would like the Berkley Small Business Solutions Underwriter to
                                    consider below:
                                </label>
                            </div>
                            <div class="mt-1">
                                <textarea class="form-control" rows="4" [class.notallowed]="indicationQG.isClearedSubmission" 
                                    [(ngModel)]="applicationInfoModel.applicationDetails.underwriterNote.answer"
                                    name="underwriterNote" id="underwriterNote" type="text"></textarea>
                            </div>
                            <div class="row mt-3 mb-3">
                                <div class="col-lg-12 text-center">
                                    <div class="col-lg-12 p-0 mt-3">
                                        <button type="button" class="btnerror float-left" title="Back"
                                            (click)="onBack('product')" [class.notallowed]="indicationQG.isClearedSubmission" >
                                            <i class="fa fa-arrow-left" aria-hidden="true"></i>
                                            Back
                                        </button>
                                        <span class="text-lg-right float-lg-right">
                                            <button type="submit" class="btnsuccess"
                                                (click)="saveAndContinue('OpenPdf')" title="View Application">
                                                <i class="fa fa-file-pdf-o" aria-hidden="true"></i>
                                                View Application
                                            </button>
                                            <button *ngIf="!indicationQG.showPriceIndication" type="submit" style="margin-left: 15px;"                
                                                class="btnsuccess" (click)="saveAndSubmit()" title="Save & Submit"
                                                data-toggle="modal">
                                                <i class="fa fa-check" aria-hidden="true"></i>
                                                Save & Submit
                                            </button>
                                            <button *ngIf="indicationQG.showPriceIndication" type="submit" style="margin-left: 15px;"
                                                class="btnsuccess" 
                                                data-toggle="modal" (click)="clearMyAgency()" [class.notallowed]="indicationQG.isClearedSubmission" 
                                                pTooltip="Submission will be cleared under your agency and you must request a formal quote before 5 days of the policy effective date."
                                                tooltipStyleClass = "custom-tooltip-spacing"
                                                tooltipPosition="bottom">
                                                <i class="fa fa-registered" aria-hidden="true"></i>
                                                Clear My Agency
                                            </button>
                                            <button *ngIf="indicationQG.showPriceIndication" type="submit" style="margin-left: 15px;"
                                                class="btnsuccess" 
                                                data-toggle="modal" (click)="requestQuoteAndSubmit()"
                                                pTooltip="Submission will be cleared under your agency, and a formal quote will be provided."
                                                tooltipStyleClass = "custom-tooltip-spacing"
                                                tooltipPosition="bottom">
                                                <i class="fa fa-handshake-o" aria-hidden="true"></i>
                                                Request Quote
                                            </button>
                                            <button type="submit" style="margin-left: 15px;"
                                                class="btnsuccess" (click)="saveAndContinue('Draft')" [class.notallowed]="indicationQG.isClearedSubmission" 
                                                id="btnsaveContinueID" title="Save as Draft & Close" data-toggle="modal">
                                                <i class="fa fa-save" aria-hidden="true"></i>
                                                Save as Draft & Close
                                            </button>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                </div>
          </form>
        </div>
    </div>
</div>

<p-toast position="center" key="confirmation" class="validation_toast appinfoconfirm" [baseZIndex]="5000">
    <ng-template let-message pTemplate="message">
        <div class="p-flex p-flex-column" style="flex: 1">
            <div class="p-text-center" [innerHTML]="message?.data">
                {{message?.data}}
            </div>
            <div class="p-grid p-fluid mt-3">
                <div class="col-md-12 text-center validation_toast_btn">
                    <button type="button" pButton (click)="onReject('confirmation')" label="Ok"
                        class="p-button-success"></button>
                </div>
            </div>
        </div>
    </ng-template>
</p-toast>
<p-toast position="center" key="confirmModal" (onClose)="onReject('confirmModal')" [baseZIndex]="5000">
    <ng-template let-message pTemplate="message">
        <div class="p-flex p-flex-column" style="flex: 1">
          <div class="p-text-center">
            <i class="pi pi-exclamation-triangle" style="font-size: 3rem"></i>
            <h4>{{ message.summary }}</h4>
            <h4 *ngIf="!!message.data.lossRunDocWarning">Minimum 3 years of loss runs will be required prior to binding the quote.</h4>
            <h4 *ngIf="!!message.data.iftaDocWarning">Most recent 4 full quarters IFTAs will be required prior to binding the quote.</h4>
          </div>
            <div class="p-grid p-fluid">
                <div class="p-col-6">
                    <button type="button" class="warnBtnSuccess float-right" title="Yes" name="btnSavePopUpYes"
                        id="btnSavePopYesID" (click)="confirmSave()">
                        <i class="fa fa-thumbs-up" aria-hidden="true"></i>
                        Yes
                    </button>
                </div>
                <div class="p-col-6">
                    <button type="button" class="warnBtnerror" title="No" name="btnSavePopUpNo" id="btnSavePopNoID"
                        (click)="onReject('confirmModal')">
                        <i class="fa fa-thumbs-down" aria-hidden="true"></i>
                        No
                    </button>
                </div>
            </div>
        </div>
    </ng-template>
</p-toast>
<p-toast position="center" key="c" (onClose)="onReject('c')" [baseZIndex]="5000">
    <ng-template let-message pTemplate="message">
        <div class="p-flex p-flex-column" style="flex: 1">
            <div class="p-text-center">
                <i class="pi pi-exclamation-triangle" style="font-size: 3rem"></i>
                <h4>{{message.summary}}</h4>
            </div>
            <div class="p-grid p-fluid">
                <div class="p-col-6">
                    <button type="button" name="btnDVCancelSubPopUpYes" id="btnDVCancelsubPopUpYesID" pButton
                        (click)="CancelmySubmission()" label="Yes" class="p-button-success"></button>
                </div>
                <div class="p-col-6">
                    <button type="button" pButton name="btnDVCancelSubPopUpNo" id="btnDVCancelsubPopUpNoID"
                        (click)="onReject('c')" label="No" class="p-button-secondary"></button>
                </div>
            </div>
        </div>
    </ng-template>
</p-toast>
<p-toast class="validation-toast" key="applicationToastKey" position="top-center"></p-toast>
<p-toast position="center" key="Delete" (onClose)="onReject('Delete')" [baseZIndex]="5000">
    <ng-template let-message pTemplate="message">
        <div class="p-flex p-flex-column" style="flex: 1">
            <div class="p-text-center">
                <i class="pi pi-exclamation-triangle" style="font-size: 3rem"></i>
                <h4>{{message.summary}}</h4>
            </div>
            <div class="p-grid p-fluid">
                <div class="p-col-6">
                    <button type="button" class="warnBtnSuccess float-right" title="Yes" name="btnLHPopUpYes"
                        id="btnLHPopYesID" (click)="confirmDelete()">
                        <i class="fa fa-thumbs-up" aria-hidden="true"></i>
                        Yes
                    </button>
                </div>
                <div class="p-col-6">
                    <button type="button" class="warnBtnerror" title="No" name="btnLHPopUpNo" id="btnLHPopNoID"
                        (click)="onReject('Delete')">
                        <i class="fa fa-thumbs-down" aria-hidden="true"></i>
                        No
                    </button>
                </div>
            </div>
        </div>
    </ng-template>
</p-toast>
